import { render, staticRenderFns } from "./DynamicTagField.vue?vue&type=template&id=b583c2f0&scoped=true&"
import script from "./DynamicTagField.vue?vue&type=script&lang=js&"
export * from "./DynamicTagField.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTagField.vue?vue&type=style&index=0&id=b583c2f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b583c2f0",
  null
  
)

export default component.exports